import { Links, Meta, Outlet, Scripts, ScrollRestoration } from "react-router";
import "./styles/app.css";

export function Layout({ children }: { children: React.ReactNode }) {
  return (
    <html lang="en">
      <head>
        <meta charSet="UTF-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1.0, maximum-scale=1.0, user-scalable=no" />
        <title>Outpost War — Military Tycoon</title>
        <Meta />
        <Links />
      </head>
      <body className="bg-mil-dark font-heading text-gray-300">
        {children}
        <ScrollRestoration />
        <Scripts />
      </body>
    </html>
  );
}

export default function Root() {
  return <Outlet />;
}
